export default __webpack_public_path__ + "static/media/ic-success.b8a8c768.svg";